import React from "react";
import styled from "styled-components";
import StarSVG from "../../assets/star.svg";

const StarCounterWrapper = styled.div`
  display: flex;

  .star-data {
    display: flex;
    flex-direction: column;
    color: #efba00;
    margin-left: 12px;
    .star-amount {
      font-weight: 900;
      font-size: 24px;
    }
    .stars {
      font-size: 14px;
      text-transform: uppercase;
    }
  }
`;

type StarCounterProps = {
  stars?: number;
};

const StarCounter = ({ stars = 0 }: StarCounterProps) => {
  return (
    <StarCounterWrapper>
      <img src={StarSVG} alt="stars" className="stars-icon" />
      <div className="star-data">
        <div className="star-amount">{stars}</div>
        <div className="stars">Stars</div>
      </div>
    </StarCounterWrapper>
  );
};

export default StarCounter;
